// 必要なコンポーネントをインポート
import UserSiteMapTemplate from "../templates/UserSiteMapTemplate"; // サイトマップ表示用テンプレート
import { Box } from '@mui/material'; // Material-UIのレイアウトコンポーネント

/** 
 * UserSiteMapPageコンポーネント
 * ユーザー向けの「サイトマップ」ページを表示するためのコンポーネント
 * UserSiteMapTemplateを利用して、サイトマップ画面を構築
 */
const UserSiteMapPage = () => {

    // サイトマップページテンプレートをレンダリング
    // 画面の最大幅を設定してレスポンシブ対応を適用
    return (
        <Box maxWidth='100%'> 
            <UserSiteMapTemplate />
        </Box>
    );
}

// UserSiteMapPageコンポーネントをデフォルトエクスポート
// 他のファイルからこのコンポーネントをインポートして利用可能にする
export default UserSiteMapPage;
